import { useEffect, useState } from 'react';
// mantine
import { Loader, Select, TextInput } from '@mantine/core';
import { useDebouncedState } from '@mantine/hooks';
// components
import RegistryItemsList from '@/pages/VersionControl/components/Registries/components/RegistryItemsList';
import NoRecords from '@/components/NoRecords';
// utils
import { useRegistriesQuery } from '@/services/designer/registries/registries.queries';

const DEBOUNCE_TIMEOUT = 500;

interface RegistriesProps {
    isProjectsV2Enabled?: boolean;
}

const Registries = ({ isProjectsV2Enabled = false }: RegistriesProps) => {
    const [registryIdn, setRegistryIdn] = useState<string | undefined>(
        'production'
    );
    const [page, setPage] = useState(1);
    const [searchTerm, setSearchTerm] = useDebouncedState('', DEBOUNCE_TIMEOUT);

    const {
        data: registries,
        isSuccess,
        isLoading
    } = useRegistriesQuery({ isProjectsV2Enabled });

    useEffect(() => {
        if (registries?.length && !registryIdn) {
            setRegistryIdn(registries[0].idn);
        }
    }, [registries, registryIdn]);

    const handleRegistryChange = (value: string | null) => {
        setPage(1);
        setRegistryIdn(value ?? undefined);
    };

    const registry = registries?.find(({ idn }) => idn === registryIdn);

    return (
        <div className="flex flex-col gap-4">
            <div className="flex gap-4">
                <Select
                    className="flex-1 max-w-sm"
                    data={registries?.map(({ idn }) => ({
                        value: idn,
                        label: idn
                    }))}
                    label="Registry"
                    size="xs"
                    value={registryIdn}
                    onChange={handleRegistryChange}
                />
                <TextInput
                    className="flex-1 max-w-sm"
                    label="Search"
                    placeholder="Search by idn"
                    size="xs"
                    onChange={(event) => {
                        setSearchTerm(event.target.value);
                    }}
                />
            </div>
            {isLoading ? (
                <div className="flex justify-center items-center py-8">
                    <Loader size={24} />
                </div>
            ) : undefined}
            {isSuccess && registries.length === 0 ? <NoRecords /> : undefined}
            {registry ? (
                <RegistryItemsList
                    isProjectsV2Enabled={isProjectsV2Enabled}
                    page={page}
                    registry={registry}
                    searchTerm={searchTerm}
                    setPage={setPage}
                />
            ) : undefined}
        </div>
    );
};

export default Registries;
